import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@zola/zola-ui';

const SelectEventDropdown = ({ eventFacetList, onSelect, }) => {
  const facetList = {
    key: 'hi',
    label: 'Your Events',
    options: eventFacetList
  };
  return (
    <div className="event--select">
      <span className="event--label">Your Events</span>
      <Dropdown
        dynamicLabel
        facetList={facetList}
        onSelect={onSelect}
        className="event--dropdown"
      />
    </div>
  );
};

SelectEventDropdown.propTypes = {
  eventFacetList: PropTypes.arrayOf(PropTypes.shape({})),
  onSelect: PropTypes.func.isRequired,
};

export default SelectEventDropdown;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/ChartCreator/SelectEventDropdown/SelectEventDropdown.jsx